import { Pipe, PipeTransform } from '@angular/core';

import { ToOrdinalNumber, ToPlainText } from '@empathy/global/functions';
import { QuestionOption, QuestionType, RatingType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Pipe({
  name: 'optionTextByType',
  pure: true
})
export class OptionTextByTypePipe implements PipeTransform {
  transform(option: QuestionOption, question: Question): string {
    switch (question.type) {
      case QuestionType.RankSort:
        if (question.ratingType === RatingType.numeric) {
          return ToOrdinalNumber(+option.value);
        }
        return ToPlainText(option.text);
      case QuestionType.Ranking:
        return ToOrdinalNumber(+option.value);

      default:
        return ToPlainText(option.text);
    }
  }
}
